import type { CSSProperties } from "vue";
import { Component, Vue, Prop } from "vue-facing-decorator";
import type { MessageStructureComponent, MessageContentSettings } from "../types";
import { ActionHandler } from "../helpers/action_handler";
import { __vueEvent } from "../constant";
import { store } from "../store/store";
import { Util } from "../util";

@Component
export default class Button extends Vue {
    //#region Class properties will be component data

    @Prop() component?: MessageStructureComponent;
    @Prop() structure?: Object;
    @Prop({
      type: Object,
      default() {
        return {};
      },
    })
    messageContentsettings?: MessageContentSettings;
    @Prop({
      type: Boolean,
      default: true, // Set default to true if not passed
    })
    formValid?: boolean;

    @Prop({
      type: Boolean,
      default: false,
    })
    isListItem?: boolean;

		/**
		 * JIRA: SD-6998
		 * To handle the click event callback to close modal popup and bottom sheet, etc.,
		 */
    @Prop({
        type: Function,
        default: null,
    })
    onClick?: (() => void) | null;
    @Prop({
        type: Object,
        default() {
            return {}
        }
    })
    
  @Prop({ type: [String, Number] })
  messageId!: string | number;

    
    customStyle?: CSSProperties;

    get type() {
        return this.component.type;
    }

    get size() {
      try {
        // Check if component or component style is not null or undefined
        if (!this.component || !this.component.style) return '';
        const size = (this.component.style as any).size;
        return size == null ? '' : size;
      } catch (ex) {
        return '';
      }
    }

    mounted() {
    this.setButtonLangAttribute();
    }

    private setButtonLangAttribute() {
      this.$nextTick(() => {
        const button = this.$el.querySelector('button');
        if (button) {
            const postback = this.component?.clickAction?.postback;
            if (postback) {
                try {
                    const params = new URLSearchParams(postback);
                    const languageCode = params.get('language_code');
                    
                    if (languageCode) {
                        button.setAttribute('lang', languageCode);
                        return;
                    }
                } catch (e) {
                    console.error('Error parsing postback URL parameters', e);
                }
            }
        }
      });
    }

    /**
     * The function `buttonWrapperClass` returns a string that represents the class name for a button
     * wrapper element, based on the size of the component's style.
     * @returns a string value. If the size is not medium or if there is an error, an empty string will
     * be returned.
     */
    get buttonWrapperClass() {
        try {
            const tempSize = (this.component.style as any).size;
            let size = tempSize == null ? '' : tempSize;
            size = size || '';

            // Check if size is a string
            if (typeof size !== 'string') {
                size = size.toString();
            }

            // Check if size is medium
            if (size && size.toLowerCase().includes('medium')) {
                return this.getClassName('button-wrapper') + ' ' + this.getClassName(size);
            }

            // If size is not medium, return empty string
            return this.getClassName('button-group');
        } catch (error) {
            return this.getClassName('button-group');
        }
    }

    //#endregion

    //#region Computed Properties

    get prefixClassName() {
      return this.$store.state.prefixClassName || "";
    }

    //#endregion

    //#region Lifecycle Hooks

    // mounted() {
    //   this.listenEvents();
    // }

    //#endregion

    //#region Main Methods

    /**
     * The function returns a class name by concatenating a prefix with a given value.
     * @param value - The value parameter is a string representing the class name that you want to
     * append to the prefixClassName.
     * @returns the concatenation of the value parameter and the prefixClassName property of the
     * store.state object.
     */
    getClassName(value) {
        return store.state.prefixClassName + value;
    }

    onElClick() {
			try {
				/**
				 * JIRA: SD-6998
				 * Check if onClick prop is being passed and trigger the click event
				 */
				if (this.onClick) this.onClick();
			} catch (error) {
				console.error("Error occurred in in 'button.ts': ", error);
			}

      this.component.messageId = this.messageId;
      
			ActionHandler.handleBtnClickAction(this.component, this.messageContentsettings);
    }

    formatMessageContent(messageContent:string){
      return Util.formatTextWithAccessibleEmojis(messageContent)
    }
    //#endregion
}
